import ResizeObserver from './components/ResizeObserver.vue'

// Install the components
export function install (app) {
  // eslint-disable-next-line vue/component-definition-name-casing
  app.component('resize-observer', ResizeObserver)
  app.component('ResizeObserver', ResizeObserver)
}

export {
  ResizeObserver,
}

// Plugin
const plugin = {
  // eslint-disable-next-line no-undef
  version: VERSION,
  install,
}

export default plugin
